(function ($) {
$('.redesign-20 .resource-grid .card-iframe iframe').each(function(){
var URL = $(this).attr("src");
$(this).parent().parent().find(".permalink").attr("href", URL);
});
$(".card-iframe").remove();
})(jQuery);